import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  "data-testid": "list-users-page",
  class: "page list-users-page"
}
const _hoisted_2 = {
  key: 0,
  class: "text-center list-pagination"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex align-center justify-center pt-5 mt-5"
}
const _hoisted_4 = { class: "text-h6" }
const _hoisted_5 = {
  key: 0,
  class: "text-center"
}
const _hoisted_6 = { class: "text-h5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, { class: "mt-4 pa-0" }, {
          default: _withCtx(() => [
            _cache[29] || (_cache[29] = _createElementVNode("div", { style: {"align-self":"center"} }, [
              _createElementVNode("h2", { class: "section-title" }, [
                _createElementVNode("span", null, "ALL Users")
              ])
            ], -1)),
            _createVNode(_component_v_layout, {
              "align-end": "",
              class: "py-2 justify-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "filter-btn elevation-4 mt-0 mx-2",
                  "data-testid": "FilterBtn",
                  ripple: false,
                  variant: "text",
                  size: "small",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createUserModal = true))
                }, {
                  default: _withCtx(() => [
                    _cache[28] || (_cache[28] = _createElementVNode("span", null, " Add User", -1)),
                    _createVNode(_component_v_icon, {
                      small: "",
                      class: "px-2 ml-2"
                    }, {
                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                        _createTextVNode("fas fa-plus", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.fetchingUsers && _ctx.users)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AppTable, {
                  "data-testid": "UserTable",
                  "table-data": _ctx.tableData,
                  loading: _ctx.fetchingUsers,
                  striped: true,
                  onViewItemClick: _cache[1] || (_cache[1] = (e) => _ctx.viewProvidersModal(e)),
                  onRemoveItemClick: _cache[2] || (_cache[2] = (e) => _ctx.removeUser(e)),
                  disablePagination: true
                }, null, 8, ["table-data", "loading"]),
                (_ctx.totalUserPage > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_ctx.totalUserPage > 1)
                        ? (_openBlock(), _createBlock(_component_v_pagination, {
                            key: 0,
                            modelValue: _ctx.currUserPage,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currUserPage) = $event)),
                            length: _ctx.totalUserPage,
                            "active-color": "primary",
                            density: "comfortable",
                            "prev-icon": "fa fa-caret-left",
                            "next-icon": "fa fa-caret-right",
                            onNext: _cache[4] || (_cache[4] = ($event: any) => (_ctx.currUserPage + 1)),
                            onPrevious: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currUserPage - 1)),
                            "total-visible": 7
                          }, null, 8, ["modelValue", "length"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.fetchingUsers && !_ctx.users)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "grey"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.providers && !_ctx.fetchingProviders)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: _ctx.providerModal,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.providerModal) = $event)),
          "onClick:outside": _cache[14] || (_cache[14] = ($event: any) => {
        _ctx.providerModal = false;
        _ctx.currPage = 1;
      }),
          persistent: "",
          "max-width": "80vw"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[30] || (_cache[30] = _createTextVNode(" Providers associated with user: ", -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.userName), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_btn, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetchAllProviders())),
                        variant: "outlined",
                        color: "primary",
                        class: "mr-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            small: "",
                            left: ""
                          }, {
                            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                              _createTextVNode("fas fa-plus", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "ml-2" }, "Add Provider", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        rounded: "",
                        size: "small",
                        variant: "flat",
                        icon: "",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                _ctx.providerModal = false;
                _ctx.currPage = 1;
              })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { small: "" }, {
                            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                              _createTextVNode("fa fa-times", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_AppTable, {
                      "table-data": _ctx.providerTableData,
                      disableSort: true,
                      disablePagination: true,
                      "default-sort-column": [{ key: 'id', order: 'asc' }],
                      onRemoveItemClick: _cache[8] || (_cache[8] = (e) => _ctx.removeProvider(e))
                    }, null, 8, ["table-data"])
                  ]),
                  _: 1
                }),
                (_ctx.totalPage > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_ctx.totalPage > 1)
                        ? (_openBlock(), _createBlock(_component_v_pagination, {
                            key: 0,
                            modelValue: _ctx.currPage,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currPage) = $event)),
                            length: _ctx.totalPage,
                            density: "comfortable",
                            "active-color": "primary",
                            "prev-icon": "fa fa-caret-left",
                            "next-icon": "fa fa-caret-right",
                            onNext: _cache[10] || (_cache[10] = ($event: any) => (_ctx.currPage + 1)),
                            onPrevious: _cache[11] || (_cache[11] = ($event: any) => (_ctx.currPage - 1)),
                            "total-visible": 7
                          }, null, 8, ["modelValue", "length"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "grey-darken-1",
                      variant: "text",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => {
              _ctx.providerModal = false;
              _ctx.currPage = 1;
            })
                    }, {
                      default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                        _createTextVNode("Close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.createUserModal,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.createUserModal) = $event)),
      "onClick:outside": _cache[21] || (_cache[21] = ($event: any) => (_ctx.createUserModal = false)),
      persistent: "",
      "max-width": "30vw"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
              default: _withCtx(() => [
                _cache[36] || (_cache[36] = _createElementVNode("div", null, [
                  _createElementVNode("div", null, "Create a new user:")
                ], -1)),
                _createElementVNode("div", null, [
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    size: "small",
                    variant: "flat",
                    icon: "",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.createUserModal = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { small: "" }, {
                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                          _createTextVNode("fa fa-times", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  onSubmit: _withModifiers(_ctx.createUser, ["prevent"]),
                  class: "py-5"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_text_field, {
                        "hide-details": "",
                        "persistent-hint": false,
                        placeholder: "User Name",
                        modelValue: _ctx.newUserName,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newUserName) = $event)),
                        class: "mb-5"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        "hide-details": "",
                        "persistent-hint": false,
                        placeholder: "User Email",
                        modelValue: _ctx.newUserEmail,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newUserEmail) = $event)),
                        class: "mb-5"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        "hide-details": "",
                        "persistent-hint": false,
                        placeholder: "Password",
                        modelValue: _ctx.newUserPassword,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newUserPassword) = $event)),
                        class: "mb-5"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_btn, {
                        block: "",
                        type: "submit",
                        color: !_ctx.newUserName || !_ctx.newUserEmail || !_ctx.newUserPassword || _ctx.addingUser ? 'disabled' : 'success',
                        class: "mt-5",
                        loading: _ctx.addingUser,
                        disabled: !_ctx.newUserName || !_ctx.newUserEmail || !_ctx.newUserPassword || _ctx.addingUser
                      }, {
                        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                          _createTextVNode(" Add ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color", "loading", "disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "grey-darken-1",
                  variant: "text",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.createUserModal = false))
                }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("Close", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.addProviderModal,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.addProviderModal) = $event)),
      persistent: "",
      "max-width": "30vw"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.showProviderForm ? 'Add Provider' : 'Select Provider'), 1),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.toggleAddProviderForm,
                  small: "",
                  variant: "outlined",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      small: "",
                      left: "",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.showProviderForm ? 'fas fa-chevron-left' : 'fas fa-plus'), 1)
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createElementVNode("span", null, "Create Provider", 512), [
                      [_vShow, !_ctx.showProviderForm]
                    ]),
                    _withDirectives(_createElementVNode("span", null, "Go back", 512), [
                      [_vShow, _ctx.showProviderForm]
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_v_label, null, {
                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                      _createTextVNode("Select a Provider", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_autocomplete, {
                    "data-testid": "Upload-Provider-List",
                    modelValue: _ctx.selectedProvider,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selectedProvider) = $event)),
                    loading: _ctx.fetchingProviders,
                    items: _ctx.filteredProviders,
                    "item-title": "name",
                    "item-value": "id",
                    class: "mx-0 mt-2",
                    type: "text",
                    "hide-no-data": "",
                    "hide-details": "",
                    label: "Provider",
                    variant: "filled"
                  }, null, 8, ["modelValue", "loading", "items"]),
                  _createVNode(_component_v_btn, {
                    block: "",
                    type: "submit",
                    color: !_ctx.selectedProvider || _ctx.addingProvider ? 'disabled' : 'success',
                    class: "mt-5",
                    loading: _ctx.addingProvider,
                    disabled: !_ctx.selectedProvider || _ctx.addingProvider,
                    onClick: _ctx.addProvider
                  }, {
                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                      _createTextVNode(" Add ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["color", "loading", "disabled", "onClick"])
                ], 512), [
                  [_vShow, !_ctx.showProviderForm]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_v_form, {
                    onSubmit: _withModifiers(_ctx.createProvider, ["prevent"]),
                    class: "py-5"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_text_field, {
                          "hide-details": "",
                          "persistent-hint": false,
                          placeholder: "Provider Name",
                          modelValue: _ctx.newProviderName,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newProviderName) = $event)),
                          class: "mb-5"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_text_field, {
                          "hide-details": "",
                          "persistent-hint": false,
                          placeholder: "Provider Email",
                          modelValue: _ctx.newProviderEmail,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newProviderEmail) = $event)),
                          class: "mb-5"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_btn, {
                          block: "",
                          type: "submit",
                          color: !_ctx.newProviderName || !_ctx.newProviderEmail || _ctx.addingProvider ? 'disabled' : 'success',
                          class: "mt-5",
                          loading: _ctx.addingProvider,
                          disabled: !_ctx.newProviderName || !_ctx.newProviderEmail || _ctx.addingProvider
                        }, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode(" Add ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["color", "loading", "disabled"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ], 512), [
                  [_vShow, _ctx.showProviderForm]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "grey-darken-1",
                  variant: "text",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.addProviderModal = false))
                }, {
                  default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                    _createTextVNode("Close", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.fetchingProviders)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}